/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: modalEditCommentsCtrl
* # alias: Ctrl
*/

export default class modalEditCommentsCtrl {

	constructor($scope, $mdDialog, services, dataInfo, ngNotify) {
		this.$scope = $scope
		this.$mdDialog = $mdDialog
		this.services = services
		this.loading = false
		this.dataInfo = dataInfo
		this.ngNotify = ngNotify
		this.ds_comments = this.dataInfo.ds_comments
		this.optionsTextEditor = [
			['bold','italics', 'underline'], 
			['justifyLeft', 'justifyCenter', 'justifyRight'], 
			['ul', 'quote', 'html'], 
			['insertImage', 'insertVideo','insertLink'], 
			['undo', 'redo']
		];

	}

	close() {
        this.$mdDialog.hide()
	}

	save() {
		let params = {
			user_id: this.dataInfo.user_id, 
			ds_biography: this.ds_comments.replace(/\u200B/g,'')
		}

        this.services.saveBiography(params).$promise.then((response) => {
        	if (!response.status) {
        		this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
        	} else {
        		this.ngNotify.set('Bitácora actualizada', 'success')
        		this.dataInfo.ds_comments = params.ds_biography
        		this.$mdDialog.hide()
        	}
        }, (err) => {
        	this.ngNotify.set('Imposible conectar con el servicio', 'error')
        })
	}

}

modalEditCommentsCtrl.$inject = ['$scope', '$mdDialog', 'services', 'dataInfo', 'ngNotify'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_dash/dialog/modalEditCommentsCtrl.js